import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

import { Dropdown as DropdownRoot, DropdownMenu, DropdownItem } from 'semantic-ui-react'

import '../../globals/scss/components/dropdown-v2.scss'

export const Dropdown = forwardRef((props, ref) => {
  const { onChange, multiple, placeholder, ...rest } = props

  const customPlaceholder = props.disabled ? 'Not Applicable' : placeholder

  const handleChange = (e, cpnProps) => {
    try {
      e.stopPropagation();
      const customEventTarget = { ...e, target: { ...e.target, ...cpnProps } }
      onChange?.(customEventTarget)
    } catch (error) {
      console.log(error)
    }
  }

  if (multiple) {
    const { value, options, ...multipleProps } = rest
    const label = options
      .filter((opt) => value?.includes(opt.value))
      .map((option) => option.text)
      .join(', ')
    return (
      <DropdownRoot
        ref={ref}
        fluid
        multiple
        text={label}
        placeholder={customPlaceholder}
        {...multipleProps}
      >
        <DropdownMenu>
          {options.map((option) => {
            const checked = value?.includes(option.value)
            return (
              <DropdownItem
                key={option.value}
                icon={
                  <span className="material-icons">
                    {checked ? 'check_box' : 'check_box_outline_blank'}
                  </span>
                }
                text={option.text}
                value={option.value}
                name={props.name}
                selected={checked}
                onClick={handleChange}
              />
            )
          })}
        </DropdownMenu>
      </DropdownRoot>
    )
  }

  return (
    <DropdownRoot
      ref={ref}
      fluid
      selection
      placeholder={customPlaceholder}
      onChange={handleChange}
      {...rest}
    />
  )
})

Dropdown.displayName = 'Dropdown'

Dropdown.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
  value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  multiple: PropTypes.bool,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
}

Dropdown.defaultProps = {
  placeholder: 'Choose an option',
}
